import { render, staticRenderFns } from "./latex.vue?vue&type=template&id=3cc2ffe0&scoped=true&"
import script from "./latex.vue?vue&type=script&lang=js&"
export * from "./latex.vue?vue&type=script&lang=js&"
import style0 from "./latex.vue?vue&type=style&index=0&id=3cc2ffe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc2ffe0",
  null
  
)

export default component.exports